import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import NewCustomButton from '../../Common/NewCustomButton';
import { ButtonTypes } from '../../Common/CustomButton';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { CloseIcon, NewCloseIcon, NewUpdateIcon } from '../../Common/Icons';
import AddAccount from './AddAccount';
import AddStaff from './AddStaff';
import '../Groups.less';

const AddMembers = ({
  closeGroupModal,
  groupModalAction,
  setRefreshGroupList,
  userHubsData = [],
  staffListData = [], // Add staffListData prop
  onMembersAdd,
  closeGroupModalHandler,
}) => {
  const trans = useSelector(translator);
  const [activeTab, setActiveTab] = useState('1');
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);

  useEffect(() => {
    setSelectedAccounts([]);
    setSelectedStaff([]);
  }, [userHubsData, staffListData]);

  // Handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  // Handle account selection
  const handleAccountSelect = (account) => {
    setSelectedAccounts((prev) => {
      const isAlreadySelected = prev.some((selected) => selected.useruuid === account.useruuid);
      if (!isAlreadySelected) {
        return [...prev, account];
      }
      return prev;
    });
  };

  // Handle account deselection
  const handleAccountDeselect = (account) => {
    setSelectedAccounts((prev) =>
      prev.filter((selected) => selected.useruuid !== account.useruuid)
    );
  };

  // Handle staff selection
  const handleStaffSelect = (staff) => {
    setSelectedStaff((prev) => {
      const isAlreadySelected = prev.some((selected) => selected.useruuid === staff.useruuid);
      if (!isAlreadySelected) {
        return [...prev, staff];
      }
      return prev;
    });
  };

  // Handle staff deselection
  const handleStaffDeselect = (staff) => {
    setSelectedStaff((prev) => prev.filter((selected) => selected.useruuid !== staff.useruuid));
  };

  // Handle add members action
  const handleAddMembers = () => {
    const membersToAdd = {
      accounts: selectedAccounts,
      staff: selectedStaff,
    };

    if (onMembersAdd) {
      onMembersAdd(membersToAdd);
    }
    closeGroupModal();
  };

  // Check if any members are selected
  const hasSelectedMembers = selectedAccounts.length > 0 || selectedStaff.length > 0;

  return (
    <div className="modal-container">
      {/* Header Section */}
      <div className="group-modal-header-container">
        <div className="group-header-icon-title-new-container">
          <div className="group-modal-header-info">
            <div className="group-header-title-new">{trans('ADDMEMBERS')}</div>
            <div className="group-header-sub-title">{trans('SELECTONEORMOREMEMBERS')}</div>
          </div>
        </div>
        <div className="group-modal-close-button" onClick={closeGroupModalHandler}>
          <CloseIcon width="20" />
        </div>
      </div>

      {/* Tabs Section */}
      <div className="add-members-tabs-container">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={handleTabChange}
          className="add-members-tabs"
          tabPosition="top"
          items={[
            {
              label: `${trans('ACCOUNTS')} ${selectedAccounts.length > 0 ? `(${selectedAccounts.length})` : ''}`,
              key: '1',
              children: (
                <AddAccount
                  userHubsData={userHubsData}
                  selectedAccounts={selectedAccounts}
                  onAccountSelect={handleAccountSelect}
                  onAccountDeselect={handleAccountDeselect}
                />
              ),
            },
            {
              label: `${trans('STAFF')} ${selectedStaff.length > 0 ? `(${selectedStaff.length})` : ''}`,
              key: '2',
              children: (
                <AddStaff
                  staffListData={staffListData}
                  selectedStaff={selectedStaff}
                  onStaffSelect={handleStaffSelect}
                  onStaffDeselect={handleStaffDeselect}
                />
              ),
            },
          ]}
        />
      </div>

      {/* Footer Buttons */}
      <div className="add-member-modal-footer">
        <NewCustomButton
          className="cancel-form-icon"
          label={trans('CANCEL')}
          icon={<NewCloseIcon style={{ fill: '#113E57' }} />}
          onClick={closeGroupModalHandler}
        />
        <NewCustomButton
          disabled={!hasSelectedMembers}
          type={ButtonTypes.primary}
          label={`${trans('ADD')} ${hasSelectedMembers ? `(${selectedAccounts.length + selectedStaff.length})` : ''}`}
          icon={
            <NewUpdateIcon
              style={{ fill: hasSelectedMembers ? '#003252' : '#ccc' }}
              className="create-group-icon-enabled"
            />
          }
          onClick={handleAddMembers}
        />
      </div>
    </div>
  );
};

export default AddMembers;
